export const DEFAULT_QUOTE_REFETCH_INTERVAL = 20000;
